import { useState, useEffect } from 'react';
import { FaCheck, FaTimes, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { downloadAllDoctorsInOneCSV } from '../DoctorsGridPageElements/downloadDoctors';
import DoctorCard from '../DoctorsGridPageElements/DoctorCards';
import doctors from '../../DB/DoctorsDetails';
import useIsMobile from '../../Hooks/IsmobileHook';
import './DashboardpagesCss/BookOPDPage.css';
import { FaFilter } from "react-icons/fa6";
import { PiStethoscopeBold } from "react-icons/pi";
import { MdFileDownload } from "react-icons/md";

const BookOPDPage = () => {

    const isMobile = useIsMobile();

    const [price, setPrice] = useState(10000);
    const [currentPage, setCurrentPage] = useState(1);
    const [showMoreSpecialties, setShowMoreSpecialties] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [sortBy, setSortBy] = useState("");

    const [searchFilters, setSearchFilters] = useState({ doctorName: '', department: '', branch: '' });
    const [debouncedSearchFilters, setDebouncedSearchFilters] = useState(searchFilters);


    const [selectedSpecialties, setSelectedSpecialties] = useState([]);
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [selectedExperience, setSelectedExperience] = useState([]);
    const [selectedConsultations, setSelectedConsultations] = useState([]);
    const [selectedRatings, setSelectedRatings] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const allSpecialties = [
        "Advanced Laparoscopic Surgeon",
        "Ayurvedacharya",
        "Cardiologist",
        "Chest Physician/ Pulmonologist",
        "Dentist",
        "Dermatologist",
        "Diabetologist",
        "Endocrinologist",
        "Dietician/Nutritionist",
        "Echo-Cardiologist",
        "Ent Specialist",
        "Eye Specialist",
        "Gastroenterologist",
        "General & Laparoscopic Surgeon",
        "General Medicine",
        "General Physician",
        "Gynecologist",
        "Gynecology and Obstetrics",
        "Hepatologist",
        "Homeopath",
        "Infertility",
        "Interventional Cardiologist",
        "Liver Transplant & HBP Surgeon",
        "Nephrologist",
        "Neurologist",
        "Neurosurgeon",
        "Oncologist",
        "Oral & Maxillofacial Surgeon",
        "Orthopaedic",
        "Orthopaedic Surgeon",
        "Paediatrician",
        "Pathologist",
        "Peadiatric Cardiology",
        "Physiotherapist",
        "Plastic Surgery",
        "Psychiatrist",
        "Psychologist",
        "Radiologist",
        "Rehabilitation Med & Pain Management",
        "Renal Transplant & Urologist",
        "Rheumatologist",
        "Sonologist",
        "Spine Surgeon",
        "Thoracic Surgeon",
        "Urologist",
        "Vascular Surgeon",
    ];

    const displayedSpecialties = showMoreSpecialties ? allSpecialties : allSpecialties.slice(0, 7);

    const [openFilters, setOpenFilters] = useState({
        specialties: true,
        gender: false,
        availability: false,
        pricing: false,
        experience: false,
        consultation: false,
        rating: false,
    });

    const toggleFilter = (key) => {
        setOpenFilters(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const toggleSelection = (value, selectedList, setSelectedList) => {
        if (selectedList.includes(value)) {
            setSelectedList(selectedList.filter(item => item !== value));
        } else {
            setSelectedList([...selectedList, value]);
        }
    };

    const handleClearAll = () => {
        setSelectedSpecialties([]);
        setSelectedGenders([]);
        setSelectedExperience([]);
        setSelectedConsultations([]);
        setSelectedRatings([]);
        // setSearchFilters({ doctorName: '', department: '' });
        setPrice(10000);
        setIsChecked(false);
        setSortBy("");
    };

    const doctorsPerPage = 12;

    const nameWords = searchFilters.doctorName.toLowerCase().split(" ").filter(Boolean);
    const deptWords = searchFilters.department.toLowerCase().split(" ").filter(Boolean);
    const branchWords = searchFilters.branch.toLowerCase().split(" ").filter(Boolean);


    const filteredDoctors = doctors.filter((doc) => {
        const matchesName = nameWords.every(word => doc.name.toLowerCase().includes(word));
        const matchesDept = deptWords.every(word => doc.specialty.toLowerCase().includes(word));
        const matchesBranch = branchWords.every(word => doc.location.toLowerCase().includes(word));
        const matchesSpecialty = selectedSpecialties.length === 0 || selectedSpecialties.includes(doc.specialty);
        const matchesGender = selectedGenders.length === 0 || selectedGenders.includes(doc.gender);
        const matchesExperience = selectedExperience.length === 0 || selectedExperience.some(min => doc.experience >= min);
        const matchesConsultation = selectedConsultations.length === 0 || selectedConsultations.some(type => doc.consultationTypes?.includes(type));
        const matchesRating = selectedRatings.length === 0 || selectedRatings.includes(Math.floor(doc.rating));
        const matchesPrice = parseInt(doc.fees) <= parseInt(price);
        const isAvailable = !isChecked || doc.availability;

        return (
            matchesName &&
            matchesDept &&
            matchesBranch &&
            matchesSpecialty &&
            matchesGender &&
            matchesExperience &&
            matchesConsultation &&
            matchesRating &&
            matchesPrice &&
            isAvailable
        );
    });



    const sortedDoctors = [...filteredDoctors].sort((a, b) => {
        if (sortBy === "priceLow") return parseInt(a.fees) - parseInt(b.fees);
        if (sortBy === "priceHigh") return parseInt(b.fees) - parseInt(a.fees);
        if (sortBy === "rating") return b.rating - a.rating;
        return 0;
    });

    const totalPages = Math.ceil(sortedDoctors.length / doctorsPerPage);
    const indexOfLastDoctor = currentPage * doctorsPerPage;
    const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
    const currentDoctors = sortedDoctors.slice(indexOfFirstDoctor, indexOfLastDoctor);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [
        searchFilters,
        selectedSpecialties,
        selectedGenders,
        selectedExperience,
        selectedConsultations,
        selectedRatings,
        price,
        isChecked
    ]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setSearchFilters(debouncedSearchFilters);
        }, 300);
        return () => clearTimeout(handler);
    }, [debouncedSearchFilters]);

    const handleSearchFilters = ({ doctorName, department, branch }) => {
        setDebouncedSearchFilters({ doctorName, department, branch });
    };


    const handleDirectoryClick = (e) => {
        e.preventDefault();
        alert("Clicked on directory button")
    }

    const handleDownloadCSV = (e) => {
        e.preventDefault();
        alert("clicked on download button")
    }


    return (
        <>
            <div className="container">
                <div className="profile-header">
                    <h2 className="rb-title pk-title package-tagg">Book An Appointment</h2>

                </div>
                <div className="dashboardBookSection">
                    <div className="gridMainContainer dashboard-grid" style={{padding:"3rem"}}>
                        {/* <div className="gridMainLeftSection">
                            {
                                isMobile ?
                                    (
                                        <div className="mobile-filters">
                                            <div className="mobile-filter-item">
                                                <label htmlFor="specialty-select">Specialties</label>
                                                <select
                                                    id="specialty-select"
                                                    value={selectedSpecialties[0] || ""}
                                                    onChange={(e) =>
                                                        setSelectedSpecialties(e.target.value ? [e.target.value] : [])
                                                    }
                                                >
                                                    <option value="">Select a specialty</option>
                                                    {allSpecialties.map((specialty, index) => (
                                                        <option key={index} value={specialty}>
                                                            {specialty}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mobile-filter-item">
                                                <label htmlFor="experience-select">Experience</label>
                                                <select
                                                    id="experience-select"
                                                    value={selectedExperience[0] || ""}
                                                    onChange={(e) =>
                                                        setSelectedExperience(e.target.value ? [parseInt(e.target.value)] : [])
                                                    }
                                                >
                                                    <option value="">Select experience</option>
                                                    {[2, 5, 8, 10, 15, 20].map((years) => (
                                                        <option key={years} value={years}>
                                                            {years}+ years
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mobile-filter-item">
                                                <label htmlFor="consultation-select">Consultation Type</label>
                                                <select
                                                    id="consultation-select"
                                                    value={selectedConsultations[0] || ""}
                                                    onChange={(e) =>
                                                        setSelectedConsultations(e.target.value ? [e.target.value] : [])
                                                    }
                                                >
                                                    <option value="">Select consultation type</option>
                                                    {["Audio Call", "Video Call", "Instant Counselling", "Chat"].map(
                                                        (type) => (
                                                            <option key={type} value={type}>
                                                                {type}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>

                                            <div className="mobile-filter-actions">
                                                <button
                                                    id="mobileFilterSearch"
                                                    className="rbdButton"
                                                    onClick={() => {
                                                        
                                                    }}
                                                >
                                                    <span className="btn-text">Search</span>
                                                </button>

                                                <button
                                                    id="mobileFilterReset"
                                                    className="rbdButton reset-Btn"
                                                    onClick={() => {
                                                        setSelectedSpecialties([]);
                                                        setSelectedExperience([]);
                                                        setSelectedConsultations([]);
                                                    }}
                                                >
                                                    <span className="btn-text">Reset</span>
                                                </button>
                                            </div>

                                        </div>
                                    )
                                    :
                                    <>
                                        
                                    </>
                            }

                        </div> */}

                        <div className="gridMainRightSection">
                            <div className="doctors-header-bar">
                                <div className="showingDiv">
                                    <h3>Showing <span>{filteredDoctors.length}</span> Doctors For You</h3>
                                </div>

                                <div className="header-controls">
                                    <div>
                                        {/* Filter Icon */}
                                        <div className="filters-Section">
                                            <label htmlFor="sort-select">Filter:</label>
                                            <button onClick={() => setIsOpen(true)} className="filter-btn">
                                                <FaFilter className="filter-icon" />
                                            </button>
                                        </div>
                                    </div>

                                    <label className="availability-switch">
                                        Availability
                                        <div className={`slider ${isChecked ? 'on' : ''}`} onClick={() => setIsChecked(!isChecked)}>
                                            {isChecked ? <FaCheck className="icon onIcon" /> : <FaTimes className="icon" />}
                                        </div>
                                    </label>

                                    <div className="sort-dropdown">
                                        <label htmlFor="sort-select">Sort By:</label>
                                        <select
                                            id="sort-select"
                                            value={sortBy}
                                            onChange={(e) => setSortBy(e.target.value)}
                                        // className='form-select'
                                        >
                                            <option value="">Default</option>
                                            <option value="priceLow">Price (Low to High)</option>
                                            <option value="priceHigh">Price (High to Low)</option>
                                            <option value="rating">Rating</option>
                                        </select>
                                    </div>


                                </div>
                                <div className='opd-buttons' style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
                                    <button className="rbdButton" onClick={handleDirectoryClick}> <span className='btn-text d-button' >
                                        <PiStethoscopeBold color='white' size={18} /> Doctor Directory
                                    </span>
                                    </button>

                                    <button className="rbdButton" onClick={handleDownloadCSV}> <span className='btn-text d-button'>
                                        <MdFileDownload color='white' size={18} />Doctor’s CSV
                                    </span>
                                    </button>
                                </div>

                            </div>


                            {currentDoctors.map((doc, idx) => (
                                <DoctorCard key={idx} {...doc} />
                            ))}

                            {filteredDoctors.length > doctorsPerPage && (
                                <div className="pagination">
                                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>‹</button>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <button key={i + 1} className={currentPage === i + 1 ? 'activePage' : ''} onClick={() => handlePageChange(i + 1)}>
                                            {i + 1}
                                        </button>
                                    ))}
                                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>›</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {isOpen && (
                    <div className="filter-overlay">
                        <div className="filter-modal">
                            <button onClick={() => setIsOpen(false)} className="close-btn-filter">✖</button>

                            <h2 className="filter-title">Apply Filters</h2>

                            <div className="filter-section">
                                <div className="filter-group">
                                    <label>Specialties</label>
                                    <select
                                        value={selectedSpecialties[0] || ""}
                                        onChange={(e) =>
                                            setSelectedSpecialties(e.target.value ? [e.target.value] : [])
                                        }
                                    >
                                        <option value="">Select a specialty</option>
                                        {allSpecialties.map((specialty, index) => (
                                            <option key={index} value={specialty}>
                                                {specialty}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="filter-group">
                                    <label>Gender</label>
                                    <div className="checkbox-group">
                                        {["Male", "Female", "Others"].map((gender) => (
                                            <label key={gender}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedGenders.includes(gender)}
                                                    onChange={() =>
                                                        toggleSelection(gender, selectedGenders, setSelectedGenders)
                                                    }
                                                />
                                                {gender}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="filter-group">
                                    <label>Experience</label>
                                    <select
                                        value={selectedExperience[0] || ""}
                                        onChange={(e) =>
                                            setSelectedExperience(
                                                e.target.value ? [parseInt(e.target.value)] : []
                                            )
                                        }
                                    >
                                        <option value="">Select experience</option>
                                        {[2, 5, 8, 10, 15, 20].map((years) => (
                                            <option key={years} value={years}>
                                                {years}+ years
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="filter-group">
                                    <label>Consultation Type</label>
                                    <select
                                        value={selectedConsultations[0] || ""}
                                        onChange={(e) =>
                                            setSelectedConsultations(e.target.value ? [e.target.value] : [])
                                        }
                                    >
                                        <option value="">Select consultation type</option>
                                        {["Audio Call", "Video Call", "Instant Counselling", "Chat"].map(
                                            (type) => (
                                                <option key={type} value={type}>
                                                    {type}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className="filter-group">
                                    <label>Rating</label>
                                    <div className="checkbox-group">
                                        {[5, 4, 3, 2, 1].map((rating) => (
                                            <label key={rating}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRatings.includes(rating)}
                                                    onChange={() =>
                                                        toggleSelection(rating, selectedRatings, setSelectedRatings)
                                                    }
                                                />
                                                {rating} Star
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="filter-actions">
                                <button
                                    onClick={() => {
                                        handleClearAll();
                                        setIsOpen(false);
                                    }}
                                    className="rbdButton reset-Btn"
                                >
                                    <span className='btn-text'>
                                        Reset
                                    </span>

                                </button>
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="rbdButton"
                                >
                                    <span className='btn-text'>
                                        Apply
                                    </span>

                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
export default BookOPDPage;